import { normalizeLanguage } from "@/utils/language";
export type MCPApiError = {
  response?: { data?: { error?: { message?: unknown }; detail?: unknown; message?: unknown } };
  message?: unknown;
};
const messageText = (value: unknown): string | undefined => {
  if (typeof value === "string") return value.trim() || undefined;
  if (Array.isArray(value)) {
    const messages = value.map(messageText).filter((item): item is string => Boolean(item));
    return messages.length ? messages.join("; ") : undefined;
  }
  if (value && typeof value === "object") {
    const detail = value as { msg?: unknown; message?: unknown };
    if (typeof detail.msg === "string") return messageText(detail.msg);
    if (typeof detail.message === "string") return messageText(detail.message);
  }
  return undefined;
};
export const mcpErrorMessage = (
  error: MCPApiError, fallback: string, language = "en", duplicateMessage?: string,
): string => {
  const data = error?.response?.data;
  const message = messageText(data?.error?.message) ?? messageText(data?.detail)
    ?? messageText(data?.message) ?? messageText(error?.message);
  if (duplicateMessage && /MCP connection with this endpoint already exists/i.test(message ?? "")) return duplicateMessage;
  return normalizeLanguage(language) === "en" ? message ?? fallback : fallback;
};
